import { Inject, Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { GOOGLE_MAPS_API_KEY } from './google-maps.tokens';

@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private loader: Loader;

  constructor(@Inject(GOOGLE_MAPS_API_KEY) apiKey: string) {
    if (!apiKey) console.warn('[GoogleMaps] Falta ApiKeyMapsSegunda en environment');
    this.loader = new Loader({
      apiKey,
      version: 'weekly',
      libraries: ['places']
    });
  }

  load(): Promise<typeof google> {
    return this.loader.load();
  }
}
